<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
        <div class="approvalBox">
          <form>
            <div class="form-line">
              <div class="textBox" style="margin-right: 20px;">
                <b class="red">*</b>
                <span class="line-text">临时停车准入：</span>
              </div>
              <el-switch
                v-model="istempCarIn"
                active-text="是"
                :disabled="!modifyState"
                inactive-text="否">
              </el-switch>
            </div>

            <div class="form-line">
              <div class="textBox2" style="margin-right: 20px;">
                <b class="red">*</b>
                <span class="line-text">一人多车白名单,在场车辆只允许一辆为白名单：</span>
              </div>
              <el-switch
                v-model="carWhiteOtherIsCasual"
                active-text="是"
                :disabled="!modifyState"
                inactive-text="否">
              </el-switch>
            </div>

            <div v-if="!modifyState" class="form-btn-box" style="display: flex;justify-content: center;">
              <button-confirm @confirm="modify" value="修改"  />
            </div>
            <div class="form-btn-box" v-if="modifyState && permissionCodes.indexOf('004026001') !== -1">
              <button-confirm @confirm="confirm" />
              <button-cancel @cancel="cancel" />
            </div>

          </form>
        </div>
  </div>
</template>

<script>
import Breadcrumb from "../../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../../components/Button/ButtonAdd";
import InputSearch from "../../../../components/Input/InputSearch";
import TableMain from "../../../../components/Table/TableMain";
import { api } from "../../../api/ParkingService";
import { errorHandler } from "../../../../utils/errorHandler";
import { nSuccess } from "../../../../utils/notice";
import { bus } from "../../../../utils/bus";
import ButtonCancel from "../../../../components/Button/ButtonCancel";
import ButtonConfirm from "../../../../components/Button/ButtonConfirm";

export default {
  components: {
    ButtonConfirm,
    ButtonCancel,
    TableMain,
    InputSearch,
    ButtonAdd,
    Breadcrumb
  },
  name: "yard-configuration",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧停车",
          name: "parking-device-management"
        },
        {
          value: "车场配置"
        }
      ],
      modifyState: false,
      configData: {},
      istempCarIn: false,
      carWhiteOtherIsCasual: false,
      permissionCodes: ""
    };
  },
  created() {
    this.getYardConfiguration();
    this.permissionCodes = bus.global.permissionCodes;
  },
  methods: {
    getYardConfiguration() {
      this.$axios
        .get(api.getYardConfiguration, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            if (data) {
              this.configData = data;
              if (data.tempCarIn) {
                this.istempCarIn = true;
              } else {
                this.istempCarIn = false;
              }
              if (data.carWhiteOtherIsCasual) {
                this.carWhiteOtherIsCasual = true;
              } else {
                this.carWhiteOtherIsCasual = false;
              }
            }
          }
        })
        .catch(errorHandler("查询失败"));
    },
    // 点击修改
    modify() {
      this.modifyState = true;
    },

    // 取消修改
    cancel() {
      this.modifyState = false;
      this.getYardConfiguration();
    },

    //修改
    confirm() {
      if (this.istempCarIn) {
        this.configData.tempCarIn = true;
      } else {
        this.configData.tempCarIn = false;
      }
      if (this.carWhiteOtherIsCasual) {
        this.configData.carWhiteOtherIsCasual = true;
      } else {
        this.configData.carWhiteOtherIsCasual = false;
      }
      this.$axios
        .post(api.modifyYardConfiguration, this.configData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("修改成功");
            this.modifyState = false;
            this.getYardConfiguration();
          }
        })
        .catch(errorHandler("修改失败"));
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
}
.form-line {
  margin: 20px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.form-line > span {
  font-size: 12px;
  color: #97a8be;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.textBox2 {
  display: inline-block;
  width: 320px;
  text-align: left;
}
.form-btn-box {
  width: 530px;
  padding: 0 124px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
</style>
<style lang="less">
.approval-manage {
  .approvalBox {
    margin-top: 20px;
  }
  .el-tabs--top.el-tabs--card .el-tabs__item:last-child {
    width: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkingOtherConfig/YardConfiguration/YardConfiguration.vue